import Vue from 'vue'
import VueRouter from 'vue-router'
import bill from '../views/bill'
// import login from '../views/login'
Vue.use(VueRouter)

const routes = [
  // 账单
  // {
  //   path: '/',
  //   name: 'login',
  //   component: login,
  //   meta:{
  //     // 页面标题title
  //     title: '月结中心'
  //   }
  // },
  {
    path: '/',
    name: 'bill',
    component: bill,
    meta:{
      // 页面标题title
      title: '月结中心'
    }
  },
  {
    path: '/bill/detailBill',
    name: 'detailBill',
    component: () => import(/* webpackChunkName: "bill" */ '@/views/bill/son/detailBill.vue'),
    meta:{
      // 页面标题title
      title: '月结中心'
    }
  },
  // 发票
  {
    path: '/invoice',
    name: 'invoice',
    // route level code-splitting
    // this generates a separate chunk (invoice.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "invoice" */ '../views/invoice'),
    meta:{
      // 页面标题title
      title: '月结中心'
    }
  },
  // 代收货款
  {
    path: '/collectionPayment',
    name: 'collectionPayment',
    component: () => import(/* webpackChunkName: "collectionPayment" */ '../views/collectionPayment'),
    meta:{
      // 页面标题title
      title: '月结中心'
    }
  },
  // 月结信息
  {
    path: '/setTing',
    name: 'setTing',
    component: () => import(/* webpackChunkName: "setTing" */ '../views/setTing'),
    meta:{
      // 页面标题title
      title: '月结中心'
    }
  },
  {
    path: '/setTing/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "bill" */ '@/views/setTing/son/download.vue'),
    meta:{
      // 页面标题title
      title: '月结中心'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "bill" */ '@/views/login/index.vue'),
    meta:{
      // 页面标题title
      title: '月结中心'
    }
  },
  {
    path: '/prestore',
    name: 'prestore',
    component: () => import(/* webpackChunkName: "bill" */ '@/views/prestore'),
    meta:{
      // 页面标题title
      title: '月结中心'
    }
  },
  {
    path: '/login/consultationService',
    name: 'login',
    component: () => import(/* webpackChunkName: "bill" */ '@/views/login/consultationService.vue'),
    meta:{
      // 页面标题title
      title: '月结中心咨询服务'
    }
  },
  {
    path: '/ok',
    name: 'ok',
    component: () => import( '@/views/ok/index.vue'),
    meta:{
      title: '月结中心'
    }
  },
]

const router = new VueRouter({
  routes
})

export default router
